class ServerError extends Error {
  constructor(codes) {
    super(`${codes && codes[0]}`);
    this.codes = codes;
  }
}

export default ServerError;
